import React, { useState } from 'react';
import { contactApi } from '../services/api';

function ContactBookingSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedback({ type: '', text: '' });

    try {
      const res = await contactApi.submitEnquiry(formData);
      setFeedback({
        type: 'success',
        text: res?.message || 'Thank you! Your message has been sent successfully.',
      });
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (err) {
      setFeedback({
        type: 'error',
        text: err.message || 'Failed to send message. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-home-minimal" id="enquiry">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column: Mascot & Title */}
          <div className="col-lg-5 text-center text-lg-start mb-4 mb-lg-0">
            <div className="contact-home-intro">
              <span className="contact-home-kicker">Get In Touch</span>
              <h2 className="contact-home-heading">
                Have Any Questions? <br />
                <span>We're Here to Help</span>
              </h2>
              <p className="contact-home-desc">
                Reach out to our care team with any questions about sessions, psychologists, or our platform.
              </p>

              <div className="contact-home-mascot">
                <img
                  src="/assets/images/mascot/get_in_touch.jpeg"
                  alt="Mascot"
                  className="mascot-img-clean"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          {/* Right Column: Clean Form */}
          <div className="col-lg-7">
            <div className="contact-home-card">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label-clean">Name *</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="form-input-clean"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label-clean">Email *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Your email address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="form-input-clean"
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label-clean">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone or WhatsApp number"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-input-clean"
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label-clean">Message *</label>
                    <textarea
                      name="message"
                      rows="3"
                      placeholder="How can we help you?"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="form-input-clean form-textarea-clean"
                    ></textarea>
                  </div>

                  {feedback.text && (
                    <div className="col-12">
                      <div className={`form-feedback-clean ${feedback.type}`}>
                        <i className={`fas ${feedback.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}`}></i>
                        <span>{feedback.text}</span>
                      </div>
                    </div>
                  )}

                  <div className="col-12 mt-3">
                    <button type="submit" disabled={loading} className="form-btn-clean">
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .contact-home-minimal {
          background: #f7f2fc;
          padding: 80px 0;
        }

        .contact-home-intro {
          padding-right: 20px;
        }

        .contact-home-kicker {
          display: inline-block;
          font-size: 13px;
          font-weight: 700;
          color: #7c4bb9;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          margin-bottom: 8px;
        }

        .contact-home-heading {
          font-size: 32px;
          font-weight: 800;
          color: #241242;
          line-height: 1.25;
          margin-bottom: 12px;
        }

        .contact-home-heading span {
          color: #7c4bb9;
        }

        .contact-home-desc {
          font-size: 15px;
          color: #6a6279;
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .contact-home-mascot {
          display: flex;
          justify-content: center;
        }

        .mascot-img-clean {
          max-height: 220px;
          width: auto;
          mix-blend-mode: multiply;
        }

        .contact-home-card {
          background: #ffffff;
          border-radius: 20px;
          padding: 38px 34px;
          box-shadow: 0 10px 30px rgba(124, 75, 185, 0.06);
          border: 1px solid #ede4fa;
        }

        .form-label-clean {
          font-size: 13px;
          font-weight: 600;
          color: #3b2c58;
          margin-bottom: 6px;
          display: block;
        }

        .form-input-clean {
          width: 100%;
          height: 46px;
          padding: 0 16px;
          background: #faf8fd;
          border: 1.5px solid #e7ddf6;
          border-radius: 10px;
          font-size: 14.5px;
          color: #24143e;
          outline: none;
          transition: border-color 0.2s;
        }

        .form-input-clean:focus {
          background: #ffffff;
          border-color: #7c4bb9;
        }

        .form-textarea-clean {
          height: auto;
          min-height: 90px;
          padding: 12px 16px;
          resize: vertical;
        }

        .form-feedback-clean {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 14px;
          border-radius: 8px;
          font-size: 13.5px;
        }

        .form-feedback-clean.success {
          background: #ecfdf5;
          color: #065f46;
          border: 1px solid #a7f3d0;
        }

        .form-feedback-clean.error {
          background: #fef2f2;
          color: #991b1b;
          border: 1px solid #fecaca;
        }

        .form-btn-clean {
          background: #7c4bb9;
          color: #ffffff;
          border: none;
          border-radius: 10px;
          padding: 12px 28px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: background 0.2s, transform 0.2s;
          width: 100%;
        }

        .form-btn-clean:hover:not(:disabled) {
          background: #6a3aa8;
          transform: translateY(-2px);
        }

        .form-btn-clean:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        @media (max-width: 991px) {
          .contact-home-card {
            padding: 28px 20px;
          }
          .contact-home-heading {
            font-size: 26px;
          }
        }
      `}</style>
    </section>
  );
}

export default ContactBookingSection;
